export default __webpack_public_path__ + "static/media/SAFRIPOL Logo Horizontal.d0ef72b4.png";